import EmailAddressWrapper from 'owa-service/lib/contract/EmailAddressWrapper';
import isValidEmailAddress from './isValidEmailAddress';

export default function isValidRecipient(email: EmailAddressWrapper): boolean {
    return (
        isValidEmailAddress(email.EmailAddress) ||
        (email.ItemId && email.MailboxType == 'PrivateDL')
    );
}
